import React, { useState } from "react";
import { Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import CON_Asientos_Detalle from "./CON_Asientos_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";

export const CON_Asientos_ = () => {
  const [data, setData] = useState([])
  const { CON_Asientos: { function_CON_Asientos_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  return (
    <PaginaListado
      Titulo="ASIENTOS CONTABLES"
      funcion={function_CON_Asientos_Listar}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/CON_Asientos_ModificacionCreacion/--NUEVO--" visible={false} />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdAsiento"
            urlEdicion="/CON_Asientos_ModificacionCreacion"
          >
            <Summary>
              <TotalItem
                column="IdAsiento"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <GroupItem
                column="IdAsiento"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
            </Summary>
            <Column caption="Código" dataField="IdAsiento" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Asiento" dataField="NumeroAsiento" width="100" alignment="Left" dataType="number" />

            <Column caption="Movimiento" alignment="Center">
              <Column caption="Cód." dataField="IdTipoMovimiento" width="80" alignment="Right" dataType="number" />
              <Column caption="Descripcion" dataField="I_TipoMovimiento" width="180" alignment="Left" dataType="string" />
              <Column caption="Operación" dataField="IdOperacion" width="100" alignment="Right" dataType="number" />
            </Column>
            <Column caption="Observaciones" dataField="Observaciones" width="100%" minWidth={100} alignment="Left" dataType="string" />
            <Column caption="Concepto" dataField="Concepto" width="200" alignment="Left" dataType="string" />

            <Column caption="Modificado" dataField="Modificado" width="120" alignment="Center" dataType="boolean" />

            <MasterDetail
              enabled={true}
              component={CON_Asientos_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
